module.exports = __webpack_public_path__ + "static/media/terms_of_service.8153f6b0.md";